import React, { useState, useEffect } from "react";

const Toast = (props) => {
  const { toast, position, autoDeleteTime } = props;
  const [autoDeleteToast, setAutoDeleteToast] = useState(true);

  useEffect(() => {
    if (autoDeleteToast) {
      const interval = setInterval(() => {
        if (autoDeleteToast) {
          deleteToast();
        }
      }, autoDeleteTime);

      return () => {
        clearInterval(interval);
      };
    }
  }, [autoDeleteToast]);

  const deleteToast = () => {
    document.getElementById("notification-container").style.display = "none";
    setAutoDeleteToast(false);
  };

  return (
    <>
      <div
        className={`notification-container ${position}`}
        id="notification-container"
      >
        <div
          className={`notification toast ${position}`}
          style={{ backgroundColor: toast.backgroundColor }}
        >
          <button id="close-button" onClick={()=>{ document.getElementById("notification-container").style.display = "none"; }}>X</button>
          <div className="notification-image">
            <img src={toast.icon} alt="" />
          </div>
          <div style={{ display: "block", width: "auto", height: "auto" }}>
            <p className="notification-title">{toast.title}</p>
            <p className="notification-message">{toast.description}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Toast;
